<template>
  <div>
    <v-breadcrumbs
      :items="breadcrumbs"
      class="grey lighten-2 white--text"
    ></v-breadcrumbs>
    <v-progress-circular
      v-if="loading"
      :size="100"
      :width="4"
      color="fmq_black"
      indeterminate
      class="d-flex mx-auto py-8 mt-8"
    ></v-progress-circular>
    <div v-else>
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-4">
          <v-btn
            small
            depressed
            color="fmq_gray"
            dark
            outlined
            to="/especialidades"
          >
            <v-icon small> mdi-arrow-left </v-icon>Voltar</v-btn
          >
        </div>
        <EspecialidadeFormulario @send="editar" :especialidade="especialidade" />
      </div>
    </div>
    <AlertSuccess
      :dialog="success"
      dialogMessage="Especialidade editada com sucesso"
      @close="goToEspecialidades"
    />
    <AlertError :alertError="error" :messageError="messageError" />
  </div>
</template>

<script>
import { editarEspecialidade, exibirEspecialidade } from "@/services/especialidades";
import EspecialidadeFormulario from "@/components/especialidades/EspecialidadeFormulario.vue";
export default {
  name: "EspecialidadeEditar",
  components: { EspecialidadeFormulario },
  data: () => ({
    breadcrumbs: [
      {
        text: "Especialidades",
        disabled: false,
        to: "/especialidades",
      },
      {
        text: "Editar Especialidades",
        disabled: true,
        to: "",
      },
    ],
    error: false,
    success: false,
    loadingBtn: false,
    messageError: null,
    especialidade: {},
    loading: false
  }),
    beforeCreate() {
    if(this.$store.state.user.data.tipo === "Representante") {
      this.$router.push({path: '/'})
    }
  },
  created() {
    this.exibir();
  },
  methods: {
    async editar(event) {
      this.error = false;
      this.sucess = false;
      this.loadingBtn = true;
      try {
        await editarEspecialidade(this.$route.params.id, event).then(() => {
          this.success = true;
        });
        this.loadingBtn = false;
      } catch (e) {
        this.loadingBtn = false;
        this.error = true;
        this.messageError = e.response.data.message;
      }
    },
    async exibir() {
      this.error = false;
      this.loading = true;
      try {
        const resp = await exibirEspecialidade(this.$route.params.id);
        this.especialidade = resp.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.error = true;
        this.messageError =  e.response.data.message;
      }
    },
    goToEspecialidades() {
      this.sucess = false;
      this.$router.push({ name: "Especialidades" });
    },
  },
};
</script>

<style></style>
